import cn from 'classnames'

import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link'
import PlainIcon, { iconType } from 'app/common/ui-next/plain-icon'

import styles from './WithdrawDraftDownload.scss'


type Props = {
  className?: string
  onClick: () => void
}

export const WithdrawDraftDownload = ({ className, onClick }: Props) => {
  return (
    <div className={cn(styles.root, className)}>
      <PlainButtonAsLink onClick={onClick}>
        {'Посмотреть заявление'}
      </PlainButtonAsLink>
      <PlainIcon
        type={iconType.PDF32}
      />
    </div>
  )
}
